import React from 'react';

import { Checkbox } from '@mantine/core';

import type { ClonotypeRow } from '../../types/antibodyTable';

interface ClonotypeSelectHeaderProps {
  allSelected: boolean;
  someSelected: boolean;
  onSelectAll: () => void;
}

/** Select-all checkbox rendered in the outer table's header row. */
export function ClonotypeSelectHeader({ allSelected, someSelected, onSelectAll }: ClonotypeSelectHeaderProps) {
  return (
    <Checkbox
      checked={allSelected}
      indeterminate={someSelected && !allSelected}
      onChange={onSelectAll}
      size="xs"
      color="#0064B0"
      aria-label="Select all clonotypes"
    />
  );
}

interface ClonotypeSelectCellProps {
  row: ClonotypeRow;
  /** Whether all of this clonotype's sequences are selected for export. */
  checked: boolean;
  /** Whether some but not all of its sequences are selected. */
  indeterminate?: boolean;
  onToggle: (row: ClonotypeRow) => void;
}

/** Per-row export checkbox in the outer table — checks/unchecks all the clonotype's sequences. */
export function ClonotypeSelectCell({ row, checked, indeterminate, onToggle }: ClonotypeSelectCellProps) {
  return (
    <Checkbox checked={checked} indeterminate={indeterminate} onChange={() => onToggle(row)} size="xs" color="#0064B0" onClick={(e) => e.stopPropagation()} />
  );
}
